export const frontEndConstants = {
	LOGIN_MUSIC_DIRECTOR_REQUEST	: 'LOGIN_MUSIC_DIRECTOR_REQUEST',
	LOGIN_MUSIC_DIRECTOR_SUCCESS	: 'LOGIN_MUSIC_DIRECTOR_SUCCESS',
	LOGIN_MUSIC_DIRECTOR_FAILURE	: 'LOGIN_MUSIC_DIRECTOR_FAILURE',
	
	LOGOUT_MUSIC_DIRECTOR 			: 'LOGOUT_MUSIC_DIRECTOR',
	
	GET_ADJUDICATORS_REQUEST : 'GET_ADJUDICATORS_REQUEST',
	GET_ADJUDICATORS_SUCCESS : 'GET_ADJUDICATORS_SUCCESS',
	GET_ADJUDICATORS_FAILURE : 'GET_ADJUDICATORS_FAILURE',

	GET_ADJUDICATORS_RECORDINGS_REQUEST : 'GET_ADJUDICATORS_RECORDINGS_REQUEST',
	GET_ADJUDICATORS_RECORDINGS_SUCCESS : 'GET_ADJUDICATORS_RECORDINGS_SUCCESS',
	GET_ADJUDICATORS_RECORDINGS_FAILURE : 'GET_ADJUDICATORS_RECORDINGS_FAILURE',


	FORGET_MUSIC_DIRECTOR_REQUEST	: 'FORGET_MUSIC_DIRECTOR_REQUEST',
	FORGET_MUSIC_DIRECTOR_SUCCESS	: 'FORGET_MUSIC_DIRECTOR_SUCCESS',
	FORGET_MUSIC_DIRECTOR_FAILURE	: 'FORGET_MUSIC_DIRECTOR_FAILURE',
};


// WEBPACK FOOTER //
// ./src/redux/constant/front-end-constant.jsx